import Metroplis from '../font/Metropolis-Regular.otf';

const metroplis = {
  fontFamily: 'Metroplis',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  // fontWeight: 400,
  src: `
    local('Metroplis'),
    local('Metroplis-Regular'),
    url(${Metroplis}) format('otf')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',

};
export default {
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': ['Montserrat', metroplis].join(','),
      },
    },
  },
  fontFamily: [
    'Montserrat',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Metroplis',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  h1: {
    fontWeight: 600,
    fontSize: '45px',
    // lineHeight: '40px',
  },
  h2: {
    fontWeight: 600,
    fontSize: '29px',
    // lineHeight: '32px',
  },
  h3: {
    fontWeight: 500,
    fontSize: '24px',
    // lineHeight: '28px',
  },
  h4: {
    fontWeight: 600,
    fontSize: '20px',
    // lineHeight: '24px',
  },
  h5: {
    fontWeight: 600,
    fontSize: '14px',
    // lineHeight: '20px',
  },
  h6: {
    fontWeight: 500,
    fontSize: '14px',
    // lineHeight: '20px',
  },
  subtitle1: {
    fontSize: '16px',
    // lineHeight: '25px',
  },
  subtitle2: {
    fontWeight: 600,
    fontSize: '10px',
  },
  body1: {
    fontSize: '12px',
  },
  body2: {
    fontSize: '12px',
  },
  button: {
    fontSize: '14px',
  },
  caption: {
    fontSize: '12px',
  },
  overline: {
    fontSize: '12px',
    fontWeight: 500,
    textTransform: 'uppercase',
  },
};
